import type {HelpTourDefinition} from "../types";

import toursManifest from "@/docs/help-knowledge/help-tours.manifest.json";

const tours = (toursManifest as {tours: HelpTourDefinition[]}).tours ?? [];

export function getHelpTourById(tourId: string) {
  return tours.find((tour) => tour.id === tourId) ?? null;
}

export function getHelpToursForScreen(domain: string, screen: string) {
  return tours.filter((tour) => tour.domain === domain && tour.screen === screen);
}
